"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCanonizedHoseCodes = void 0;
const getHoseCodesForAtomsInternal_js_1 = require("../hose/getHoseCodesForAtomsInternal.js");
const tagAtom_1 = require("../util/tagAtom");
function getCanonizedHoseCodes(diaMol, options = {}) {
    const heterotopicSymmetryRanks = diaMol.heterotopicSymmetryRanks;
    const moleculeWithH = diaMol.moleculeWithH;
    const finalRanks = diaMol.finalRanks;
    const canonizedHoseCodes = new Array(moleculeWithH.getAllAtoms());
    moleculeWithH.ensureHelperArrays(diaMol.molecule.getOCL().Molecule.cHelperSymmetryStereoHeterotopicity);
    const cache = {};
    for (let i = 0; i < diaMol.moleculeWithH.getAllAtoms(); i++) {
        const rank = heterotopicSymmetryRanks[i];
        if (rank && cache[rank]) {
            canonizedHoseCodes[finalRanks[i]] = cache[rank].diaID;
            continue;
        }
        const tempMolecule = diaMol.moleculeWithH.getCompactCopy();
        (0, tagAtom_1.tagAtom)(tempMolecule, i);
        const hoses = (0, getHoseCodesForAtomsInternal_js_1.getHoseCodesForAtomsInternal)(tempMolecule, options);
        canonizedHoseCodes[finalRanks[i]] = hoses;
    }
    return canonizedHoseCodes;
}
exports.getCanonizedHoseCodes = getCanonizedHoseCodes;
//# sourceMappingURL=getCanonizedHoseCodes.js.map